import "./styles.css";
import { useDispatch, useSelector } from "react-redux";
import { toggleOutOfServiceModal } from "../../redux/slices/appSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleExclamation,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { RootState } from "../../redux/store";

const OutOfServiceModal = () => {
  const dispatch = useDispatch();
  const isOutOfServiceTime = useSelector(
    (store: RootState) => store.app.isOutOfServiceTime
  );
  const appSettings = useSelector((store: RootState) => store.app.appSettings);

  const isAppOutOfService = useSelector(
    (store: RootState) => store.app.isAppOutOfService
  );

  return (
    <div className='modal'>
      <div
        className='modal-background'
        onClick={() => dispatch(toggleOutOfServiceModal())}
      ></div>
      <div className='modal-content'>
        <div className='box'>
          <div className='flex border-b'>
            <div className='flex-1 font-bold p-4'>{}</div>
            <div>
              <button
                onClick={() => dispatch(toggleOutOfServiceModal())}
                className='p-4'
                aria-label='close'
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
          </div>

          <div className='mt-4 text-rose-900 text-6xl text-center'>
            <FontAwesomeIcon icon={faCircleExclamation} />
          </div>
          <div className='p-2'>
            {!isAppOutOfService && isOutOfServiceTime && (
              <>
                <div className=' text-center text-xl font-bold'>
                  سفارش نمی پذیریم
                </div>
                <div className='mt-2 text-center'>
                  <div> سفارش گیری از </div>
                  {appSettings.shifts.shift_one.start} الی{" "}
                  {appSettings.shifts.shift_one.end} و{" "}
                  {appSettings.shifts.shift_two.start} الی{" "}
                  {appSettings.shifts.shift_two.end}
                </div>
              </>
            )}

            {isAppOutOfService && (
              <>
                <div className='text-center text-xl font-bold'>
                  {" "}
                  سفارش نمی پذیریم
                </div>
              </>
            )}
          </div>

          <div className='p-2 border-t flex'>
            <div className='flex-1'>
              <button
                onClick={() => dispatch(toggleOutOfServiceModal())}
                className='px-4 py-2 w-full rounded font-bold bg-rose-900 text-white'
              >
                بستن
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OutOfServiceModal;
